import { render, staticRenderFns } from "./AssignDevices.vue?vue&type=template&id=55d988ea"
import script from "./AssignDevices.vue?vue&type=script&lang=ts"
export * from "./AssignDevices.vue?vue&type=script&lang=ts"
import style0 from "./AssignDevices.vue?vue&type=style&index=0&id=55d988ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports